import React, { useState, useEffect } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useCart } from "../context/CartContext";
import axios from "axios";
import ReactGA from "react-ga4";
import { useSnackbar } from "notistack";
import { formatarData, formatarValor } from "../components/formatarValores";

// import userModel from "../../../backend/models/userModel";

const Cart = () => {
  const User = JSON.parse(localStorage.getItem("user"));
  const { cartItems, decreaseCartItemQuantity, addToCart, clearCart } =
    useCart();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [temProdutos, setTemProdutos] = useState(false);

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.priceInCents * item.quantity,
    0
  );

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "acessou_carrinho",
    });

    ReactGA.event({
      category: "entrada_no_carrinho",
      action: "atleta_no_carrinho",
      label: User.nome, // optional
    });
    ReactGA.event({
      category: "entrada_no_carrinho",
      action: "valor_do_carrinho",
      label: totalPrice / 100, // optional
    });
  }, []);

  useEffect(() => {
    setTemProdutos(cartItems.length > 0);
  }, [cartItems]);

  if (cartItems.length === 0) {
    return (
      <div className="text-black text-3xl text-center my-48">
        Seu carrinho está vazio.
        <div className=" text-center mb-8">
          <NavLink to="/ar/shop" className="btn btn-accent mt-4">
            Ir para a loja
          </NavLink>
        </div>
      </div>
    );
  }

  // const totalPrice = cartItems.reduce(
  //   (acc, item) => acc + item.priceInCents * item.quantity,
  //   0
  // );

  const handleCheckout = async () => {
    const gerarChavePIX = async () => {
      const data = {
        codigo: User.id,
        valor: totalPrice / 100,
      };

      try {
        const response = await axios.post(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/compras/pagamento/gerarPayload`,
          data
        );

        return response.data;
      } catch (error) {
        console.error("Problemas na geração do QRCODE", error);
      }
    };

    // armazenar dados da compra
    const salvarCompra = async () => {
      const chavePix = await gerarChavePIX();
      const data = {
        idAtleta: User.id,
        quantity: cartItems.length,
        totalPrice: totalPrice / 100,
        status: "Pendente",
        produtos: cartItems,
        chavePix: chavePix.chavePix,
      };
      try {
        const response = await axios.post(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/compras/criarCompra`,
          data
        );
        localStorage.setItem("idCompra", response.data.id);

        navigate("/ar/pagamentos/novo");

        return response.data;
      } catch (error) {
        console.error("Problemas na criação da ordem", error);
        enqueueSnackbar(
          "Problemas na criação de sua orgem. Procure o administrador",
          { variant: "warning" }
        );
      }
    };
    await salvarCompra();
  };

  return (
    <div className="p-4 mt-16 max-w-[1400px] mx-auto">
      <table className="table mt-16">
        <thead>
          <tr className="text-base">
            <th className="text-start">Fotos</th>
            <th className="text-center">Valor</th>
            <th className="text-center">Ação</th>
          </tr>
        </thead>
        <tbody>
          {cartItems.map((item, index) => (
            <tr key={index} className="bg-base-100 hover:bg-base-300">
              <td className="py-3 px-2 text-center">
                <img
                  src={item.imageSample}
                  alt={item.name}
                  className="rounded-md mb-4 w-[80px] h-[100px] object-cover "
                />
              </td>
              <td className="py-3 px-2 text-center">
                R$
                {(item.priceInCents / 100).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </td>

              <td className="py-3 px-2 text-center">
                <button
                  onClick={() => decreaseCartItemQuantity(item._id)}
                  className="  font-bold hover:underline"
                >
                  Remover
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-center fixed top-[74px] right-4">
        <button
          onClick={handleCheckout}
          className="bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-md"
        >
          Ir para pagamento
        </button>
      </div>
      {temProdutos ? (
        <div className="fixed top-[74px] left-4 z-4">
          <button
            onClick={() => {
              navigate("/ar/cart");
            }}
            className="bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-md"
          >
            Total: R$
            {(totalPrice / 100).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </button>
        </div>
      ) : null}
    </div>
  );
};
export default Cart;
